/* Blackheath collection engine — 3 switchable views over the WHOLE collection:
   Grid (Tidy Catalogue) · Table (Expandable Catalogue) · Feature (Editorial Lots).
   Full faceted filters + range sliders + active chips + URL state + 50/page pagination. */
(function () {
  "use strict";
  var PER_PAGE = 50;
  var MAX_PAGES = 40; /* cap client-side load at 2,000 items; bigger collections page on the server */
  var CATS = [
    ['country', 'Country'], ['reign', 'Reign'], ['condition', 'Condition'], ['mint_used', 'Mint / Used'],
    ['format', 'Format'], ['emission', 'Issue type'], ['printing', 'Printing'], ['colour', 'Colour'],
    ['perforation', 'Perforation'], ['watermark', 'Watermark'], ['paper', 'Paper'], ['series', 'Series'], ['theme', 'Theme']
  ];
  var RANGES = [['price', 'Price (£)'], ['catval', 'Catalogue value (£)'], ['year', 'Year']];
  var COLUMNS = [
    { k: 'sku', label: 'Item', num: true, def: true }, { k: 'title', label: 'Description', def: true },
    { k: 'country', label: 'Country', def: true }, { k: 'reign', label: 'Reign' },
    { k: 'sg', label: 'SG', def: true }, { k: 'scott', label: 'Scott' }, { k: 'michel', label: 'Michel' }, { k: 'yvert', label: 'Yvert' },
    { k: 'denomination', label: 'Denom.' }, { k: 'colour', label: 'Colour' }, { k: 'perforation', label: 'Perf.' },
    { k: 'watermark', label: 'Wmk' }, { k: 'paper', label: 'Paper' }, { k: 'printing', label: 'Printing' },
    { k: 'emission', label: 'Issue type' }, { k: 'series', label: 'Series' }, { k: 'theme', label: 'Themes' },
    { k: 'format', label: 'Format' }, { k: 'condition', label: 'Condition', def: true }, { k: 'mint_used', label: 'Mint/Used' },
    { k: 'price', label: 'Our price', num: true, def: true }, { k: 'catval', label: 'Catalogue', num: true, def: true }, { k: 'year', label: 'Year', num: true }
  ];
  var FACET_LABEL = {}; CATS.forEach(function (c) { FACET_LABEL[c[0]] = c[1]; });

  function e(s) { return (s == null ? '' : String(s)).replace(/[&<>]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;' }[c]; }); }
  function a(s) { return e(s).replace(/"/g, '&quot;'); }
  function norm(s) { return (s == null ? '' : String(s)).toLowerCase().replace(/\s+/g, ' ').trim(); }

  function boot() {
    var section = document.querySelector('.bhs-collx');
    if (!section) return;
    var $ = function (s) { return section.querySelector(s); };
    var dataTable = $('[data-bhs-data]'), dataBody = dataTable ? dataTable.querySelector('tbody') : null;
    var grid = $('[data-bhs-grid]'), tableWrap = $('[data-bhs-tablewrap]'), thead = $('[data-bhs-thead]'), tbody = $('[data-bhs-tbody]');
    var feature = $('[data-bhs-feature]'), clientPager = $('[data-bhs-clientpager]'), gridPager = $('[data-bhs-gridpager]');
    var filterUiEl = $('[data-bhs-filterui]'), keywordEl = $('[data-bhs-keyword]'), sortSel = $('[data-bhs-sort]');
    var countEl = $('[data-bhs-count]'), loadingEl = $('[data-bhs-loading]'), emptyEl = $('[data-bhs-emptystate]');
    var sidebar = $('[data-bhs-sidebar]'), filterToggle = $('[data-bhs-filtertoggle]');
    var gridCtrls = $('[data-bhs-gridctrls]'), colsMenuWrap = $('[data-bhs-colsmenu]'), colMenu = $('[data-bhs-colmenu]');
    var chipsEl = $('[data-bhs-chips]'), browseEl = $('[data-bhs-browse]'), browseChips = $('[data-bhs-browse-chips]');
    var collUrl = section.getAttribute('data-coll-url') || '';

    var dataset = [], curPage = 1, sortState = null, rangeState = {}, ready = false, view = 'grid';
    var grandTotal = parseInt(section.getAttribute('data-count') || '0', 10), capped = false;
    var byItem = {};
    var colState = {}; COLUMNS.forEach(function (c) { colState[c.k] = !!c.def; });

    /* ---------- Build dataset (every field) ---------- */
    function buildDataset() {
      dataset = Array.prototype.slice.call(dataBody.children).map(function (tr) {
        function cell(k) { var c = tr.querySelector('[data-key="' + k + '"]'); return c ? c.textContent.trim() : ''; }
        function num(k) { var c = tr.querySelector('[data-key="' + k + '"]'); var v = c ? parseFloat(c.getAttribute('data-sort') || c.textContent) : NaN; return v; }
        var cents = num('price');
        var d = {
          url: tr.getAttribute('data-url'), img: tr.getAttribute('data-img'), title: tr.getAttribute('data-title') || cell('title'),
          vid: tr.getAttribute('data-vid'), available: tr.getAttribute('data-available') === 'true', priceText: tr.getAttribute('data-price-text'),
          compareText: tr.getAttribute('data-compare-text') || '', desc: tr.getAttribute('data-desc') || '',
          sku: cell('sku'), sg: cell('sg'), scott: cell('scott'), michel: cell('michel'), yvert: cell('yvert'),
          country: cell('country'), reign: cell('reign'), condition: cell('condition'), mint_used: cell('mint_used'),
          format: cell('format'), emission: cell('emission'), printing: cell('printing'), colour: cell('colour'),
          denomination: cell('denomination'), perforation: cell('perforation'), watermark: cell('watermark'), paper: cell('paper'),
          series: cell('series'), theme: cell('theme'),
          price: isNaN(cents) ? NaN : cents / 100, catval: num('catval'), year: num('year')
        };
        var sgm = /(\d+)/.exec(d.sg || ''); d.sgnum = sgm ? parseInt(sgm[1], 10) : NaN;
        var skm = /(\d+)/.exec(d.sku || ''); d.skunum = skm ? parseInt(skm[1], 10) : NaN;
        d.blob = (d.title + ' ' + d.sku + ' ' + d.country + ' ' + d.sg + ' ' + d.scott + ' ' + d.michel + ' ' + d.condition + ' ' + d.colour + ' ' + d.theme + ' ' + d.series).toLowerCase();
        return d;
      });
    }

    /* ---------- Filter sidebar ---------- */
    function buildFilterUI() {
      rangeState = {};
      var html = '';
      CATS.forEach(function (f) {
        var counts = {};
        dataset.forEach(function (d) {
          var raw = d[f[0]]; if (!raw) return;
          (f[0] === 'theme' ? raw.split(', ') : [raw]).forEach(function (p) { p = p.trim(); if (p) counts[p] = (counts[p] || 0) + 1; });
        });
        var vals = Object.keys(counts); if (vals.length < 2) return;
        vals.sort(function (x, y) { return counts[y] - counts[x] || x.localeCompare(y); });
        html += '<details class="bhs-fgroup"><summary>' + e(f[1]) + ' <span class="bhs-fgroup__n">' + vals.length + '</span></summary><div class="bhs-fopts">';
        vals.forEach(function (v) { html += '<label class="bhs-fopt"><input type="checkbox" data-fkey="' + f[0] + '" value="' + a(v) + '"><span class="bhs-fopt__t">' + e(v) + '</span><span class="bhs-fopt__c">' + counts[v] + '</span></label>'; });
        html += '</div></details>';
      });
      RANGES.forEach(function (r) {
        var vals = dataset.map(function (d) { return d[r[0]]; }).filter(function (v) { return !isNaN(v) && v > 0; });
        if (vals.length < 2) return;
        var min = Math.floor(Math.min.apply(null, vals)), max = Math.ceil(Math.max.apply(null, vals));
        if (min >= max) return;
        rangeState[r[0]] = { min: min, max: max, lo: min, hi: max };
        html += '<details class="bhs-fgroup" data-rangegroup="' + r[0] + '"><summary>' + e(r[1]) + '</summary>'
          + '<div class="bhs-range" data-range="' + r[0] + '"><div class="bhs-range__track"><input type="range" class="bhs-range__lo" min="' + min + '" max="' + max + '" value="' + min + '"><input type="range" class="bhs-range__hi" min="' + min + '" max="' + max + '" value="' + max + '"></div>'
          + '<div class="bhs-range__inputs"><input type="number" class="bhs-range__nlo" value="' + min + '" min="' + min + '" max="' + max + '" aria-label="From"><span>to</span><input type="number" class="bhs-range__nhi" value="' + max + '" min="' + min + '" max="' + max + '" aria-label="To"></div></div></details>';
      });
      filterUiEl.innerHTML = html || '<p class="bhs-collx__nofilters">No filters available.</p>';
      filterUiEl.querySelectorAll('input[data-fkey]').forEach(function (cb) { cb.addEventListener('change', function () { curPage = 1; render(); }); });
      filterUiEl.querySelectorAll('[data-range]').forEach(function (wrap) {
        var key = wrap.getAttribute('data-range'), st = rangeState[key];
        var lo = wrap.querySelector('.bhs-range__lo'), hi = wrap.querySelector('.bhs-range__hi'), nlo = wrap.querySelector('.bhs-range__nlo'), nhi = wrap.querySelector('.bhs-range__nhi');
        st.els = { lo: lo, hi: hi, nlo: nlo, nhi: nhi };
        function sync(fromNumbers) {
          var x = parseFloat(fromNumbers ? nlo.value : lo.value), y = parseFloat(fromNumbers ? nhi.value : hi.value);
          if (isNaN(x)) x = st.min; if (isNaN(y)) y = st.max;
          if (x > y) { var t = x; x = y; y = t; }
          x = Math.max(st.min, Math.min(x, st.max)); y = Math.max(st.min, Math.min(y, st.max));
          st.lo = x; st.hi = y; lo.value = x; hi.value = y; nlo.value = x; nhi.value = y; curPage = 1; render();
        }
        lo.addEventListener('input', function () { sync(false); }); hi.addEventListener('input', function () { sync(false); });
        nlo.addEventListener('change', function () { sync(true); }); nhi.addEventListener('change', function () { sync(true); });
      });
    }

    /* ---------- Filtering / sorting ---------- */
    function gather() {
      var f = { cats: {}, ranges: {}, keyword: '' };
      filterUiEl.querySelectorAll('input[data-fkey]:checked').forEach(function (cb) { var k = cb.getAttribute('data-fkey'); (f.cats[k] = f.cats[k] || []).push(cb.value.toLowerCase()); });
      Object.keys(rangeState).forEach(function (k) { var s = rangeState[k]; if (s.lo > s.min || s.hi < s.max) f.ranges[k] = [s.lo, s.hi]; });
      if (keywordEl && keywordEl.value.trim()) f.keyword = keywordEl.value.trim().toLowerCase();
      return f;
    }
    function matches(d, f) {
      if (f.keyword && d.blob.indexOf(f.keyword) === -1) return false;
      for (var k in f.cats) {
        var dv = (d[k] || '').toLowerCase();
        if (k === 'theme') { if (!f.cats[k].some(function (v) { return dv.indexOf(v) !== -1; })) return false; }
        else if (f.cats[k].indexOf(dv) === -1) return false;
      }
      for (var rk in f.ranges) { var v = d[rk]; if (isNaN(v) || v < f.ranges[rk][0] || v > f.ranges[rk][1]) return false; }
      return true;
    }
    function sortList(list) {
      if (!sortState) return list;
      var key = sortState.key, numeric = sortState.numeric, asc = sortState.asc;
      return list.slice().sort(function (p, q) {
        var av, bv;
        if (numeric) { av = parseFloat(p[key]); bv = parseFloat(q[key]); if (isNaN(av)) av = -Infinity; if (isNaN(bv)) bv = -Infinity; }
        else { av = (p[key] || '').toString().toLowerCase(); bv = (q[key] || '').toString().toLowerCase(); }
        if (av < bv) return asc ? -1 : 1; if (av > bv) return asc ? 1 : -1; return 0;
      });
    }

    /* ---------- Renderers ---------- */
    function catVal(d) { return (!isNaN(d.catval) && d.catval > 0) ? '£' + Math.round(d.catval) : ''; }
    function cardForm(d, cls) { return d.available ? '<form class="' + cls + '-form" method="post" action="/cart/add"><input type="hidden" name="id" value="' + a(d.vid) + '"><button class="' + cls + '" type="submit">Add to basket</button></form>' : ''; }

    function catCard(d) {
      var meta = '';
      if (d.series) meta += '<span class="cc-series">' + e(d.series) + '</span>';
      if (d.condition) meta += '<span class="cc-tag">' + e(d.condition) + '</span>';
      return '<article class="cc-card' + (d.available ? '' : ' is-sold') + '">'
        + '<a class="cc-figure" href="' + a(d.url) + '">' + (d.img ? '<img src="' + a(d.img) + '" loading="lazy" alt="' + a(d.title) + '">' : '') + (d.available ? '' : '<span class="cc-sold">Sold</span>') + '</a>'
        + '<h3 class="cc-title"><a href="' + a(d.url) + '">' + e(d.title) + '</a></h3>'
        + '<div class="cc-meta"><span class="cc-meta-text">' + meta + '</span></div>'
        + '<div class="cc-foot"><div class="cc-pricerow"><span class="cc-price">' + (d.priceText || '') + '</span>' + (d.compareText ? '<span class="cc-was">' + d.compareText + '</span>' : '') + '</div>'
        + '<div class="cc-actions"><a class="cc-view" href="' + a(d.url) + '">View item</a>'
        + (d.available ? '<form class="cc-add-form" method="post" action="/cart/add"><input type="hidden" name="id" value="' + a(d.vid) + '"><button class="cc-add" type="submit">Add to basket</button></form>' : '<span class="cc-soldtag">Sold</span>')
        + '</div></div></article>';
    }

    function visibleCols() { return COLUMNS.filter(function (c) { return colState[c.k]; }); }
    function buildThead() {
      var cols = visibleCols();
      var h = '<tr><th class="ec-th-thumb">Image</th>';
      cols.forEach(function (c) {
        var sortedCls = sortState && sortState.key === c.k ? (sortState.asc ? ' sort-asc' : ' sort-desc') : '';
        h += '<th class="sortable' + sortedCls + '" data-key="' + c.k + '" data-type="' + (c.num ? 'num' : 'text') + '">' + e(c.label) + '<span class="arrow">' + (sortedCls ? (sortState.asc ? '▲' : '▼') : '↕') + '</span></th>';
      });
      h += '<th class="ec-th-caret" aria-hidden="true"></th></tr>';
      thead.innerHTML = h;
      thead.querySelectorAll('th.sortable').forEach(function (th) {
        th.addEventListener('click', function () {
          var key = th.getAttribute('data-key'), numeric = th.getAttribute('data-type') === 'num';
          if (sortState && sortState.key === key) sortState.asc = !sortState.asc;
          else sortState = { key: key, numeric: numeric, asc: !numeric };
          if (sortSel) sortSel.value = '';
          curPage = 1; render();
        });
      });
    }
    function cellHTML(c, d) {
      if (c.k === 'price') return '<span class="ec-price">' + (d.priceText || '') + '</span>';
      if (c.k === 'catval') return catVal(d) ? '<span class="ec-cat">' + catVal(d) + '</span>' : '';
      if (c.k === 'sku') return '<span class="ec-num">#' + e(d.sku) + '</span>';
      if (c.k === 'sg') return '<span class="ec-sg">' + e(d.sg) + '</span>';
      if (c.k === 'condition') return d.condition ? '<span class="ec-cond">' + e(d.condition) + '</span>' : '';
      if (c.k === 'title') return '<span class="ec-desc-main">' + e(d.title) + '</span>';
      if (c.num) { var v = d[c.k]; return !isNaN(v) && v > 0 ? '<span class="ec-num">' + e(v) + '</span>' : ''; }
      return e(d[c.k] || '');
    }
    function metaRows(d) {
      var rows = '';
      function r(k, v) { if (v != null && v !== '') rows += '<tr><td>' + k + '</td><td>' + e(v) + '</td></tr>'; }
      r('Item no.', d.sku); r('Country', d.country); r('Reign / era', d.reign); r('Series', d.series); r('Issue type', d.emission);
      r('Denomination', d.denomination); r('Colour', d.colour); r('Perforation', d.perforation); r('Watermark', d.watermark);
      r('Paper', d.paper); r('Printing', d.printing); r('Stanley Gibbons', d.sg ? 'SG ' + d.sg : ''); r('Scott', d.scott);
      r('Michel', d.michel); r('Yvert', d.yvert); r('Condition', d.condition ? (d.condition + (d.mint_used ? ' (' + d.mint_used + ')' : '')) : ''); r('Themes', d.theme);
      r('Catalogue value (ref.)', catVal(d));
      return rows;
    }
    function compactCells(d) {
      var h = '<td class="ec-c-thumb"><span class="ec-thumb">' + (d.img ? '<img src="' + a(d.img) + '" loading="lazy" alt="' + a(d.title) + '">' : '') + '</span></td>';
      visibleCols().forEach(function (c) { h += '<td class="ec-c-' + c.k + '">' + cellHTML(c, d) + '</td>'; });
      h += '<td class="ec-caret" aria-hidden="true">&rsaquo;</td>';
      return h;
    }
    function detailCell(d) {
      var span = visibleCols().length + 2;
      var descSame = !d.desc || norm(d.desc).replace(/…+$/, '').trim() === norm(d.title);
      var descBlock = descSame ? '' : '<h5>Description</h5><p>' + e(d.desc) + '</p>';
      return '<td class="ec-exp-cell" colspan="' + span + '"><div class="ec-exp-wrap"><button type="button" class="ec-exp-close" data-ec-close aria-label="Close details">&times;</button>'
        + '<div class="ec-exp-grid">'
        + '<a class="ec-exp-img" href="' + a(d.url) + '">' + (d.img ? '<img src="' + a(d.img) + '" loading="lazy" alt="' + a(d.title) + '">' : '') + '</a>'
        + '<div class="ec-exp-meta"><div class="ec-exp-title">' + e(d.title) + '</div>' + descBlock + '<table class="ec-meta-table"><tbody>' + metaRows(d) + '</tbody></table></div>'
        + '<div class="ec-exp-cta"><div class="ec-exp-price"><span class="now">' + (d.priceText || '') + '</span>' + (d.compareText ? '<span class="was">' + d.compareText + '</span>' : '') + '</div>'
        + (catVal(d) ? '<div class="ec-exp-cat">Catalogue value (ref.) ' + catVal(d) + '</div>' : '')
        + '<a class="ec-exp-view" href="' + a(d.url) + '">View item</a>'
        + (d.available ? '<form method="post" action="/cart/add" class="ec-exp-form"><input type="hidden" name="id" value="' + a(d.vid) + '"><button class="ec-exp-add" type="submit">Add to basket</button></form>' : '<span class="ec-soldtag">Sold</span>')
        + '<div class="ec-exp-badges">'
        + '<img src="https://cdn.shopify.com/s/files/1/0573/9128/4385/files/pts_shielf.png?v=1643234159" alt="PTS" loading="lazy">'
        + '<img src="https://cdn.shopify.com/s/files/1/0573/9128/4385/files/ipda_logo_0f441e90-39da-4e1a-9bb1-7446b08d8489.png?v=1701958862" alt="IPDA" loading="lazy">'
        + '<img src="https://cdn.shopify.com/s/files/1/0573/9128/4385/files/gbpslogo_1.png?v=1732704386" alt="GBPS" loading="lazy">'
        + '<a href="https://www.ebay.co.uk/str/blackheathstamps" target="_blank" rel="noopener"><img src="https://cdn.shopify.com/s/files/1/0573/9128/4385/files/toprated_5bd03c8e-484d-448c-8e9b-8506e391afc4.png" alt="eBay Top Rated Seller" loading="lazy"></a>'
        + '</div>'
        + '<ul class="ec-exp-trust"><li>The exact item pictured, one of one</li><li>PTS &amp; IPDA accredited dealer</li><li>Honest, specialist grading</li><li>Secure checkout &amp; tracked dispatch</li><li>90-day returns guarantee</li></ul>'
        + '</div></div></div></td>';
    }
    function compactRow(d) { return '<tr class="ec-row" data-item="' + a(d.sku) + '" tabindex="0" role="button" aria-expanded="false">' + compactCells(d) + '</tr>'; }

    function lotMarkup(d) {
      var cells = [];
      if (d.sg) cells.push('<td><span class="k">SG</span><span class="v">' + e(d.sg) + '</span></td>');
      if (d.scott) cells.push('<td><span class="k">Scott</span><span class="v">' + e(d.scott) + '</span></td>');
      if (d.michel) cells.push('<td><span class="k">Michel</span><span class="v">' + e(d.michel) + '</span></td>');
      if (d.yvert) cells.push('<td><span class="k">Yvert</span><span class="v">' + e(d.yvert) + '</span></td>');
      var cattable = cells.length ? '<table class="lot__cattable"><tbody><tr>' + cells.join('') + '</tr></tbody></table>' : '';
      var mrows = '';
      function mr(k, v) { if (v) mrows += '<tr><td>' + k + '</td><td>' + e(v) + '</td></tr>'; }
      mr('Issue type', d.emission); mr('Perforation', d.perforation); mr('Watermark', d.watermark); mr('Series', d.series); mr('Themes', d.theme);
      var body = mrows ? '<table class="lot__metatable"><tbody>' + mrows + '</tbody></table>' : '';
      return '<article class="lot">'
        + '<div class="lot__img">' + (d.available ? '' : '<span class="lot__sold">Sold</span>') + (d.img ? '<img src="' + a(d.img) + '" loading="lazy" alt="' + a(d.title) + '">' : '') + '</div>'
        + '<div class="lot__info"><div class="lot__top"><span class="lot__kicker">' + e([d.country, d.reign].filter(Boolean).join(' · ')) + '</span>' + (d.condition ? '<span class="lot__cond">' + e(d.condition) + '</span>' : '') + '</div>'
        + '<h3 class="lot__title">' + e(d.title) + '</h3>'
        + cattable
        + body
        + '<div class="lot__divider"></div>'
        + '<div class="lot__foot"><div class="lot__prices"><div class="lot__price"><span class="lab">Our price</span><span class="val">' + (d.priceText || '') + '</span></div>'
        + (d.compareText ? '<div class="lot__price is-cat"><span class="lab">Was</span><span class="val">' + d.compareText + '</span></div>' : '') + '</div>'
        + '<div class="lot__ctas"><a class="lot__view" href="' + a(d.url) + '">View item</a>'
        + (d.available ? '<form class="lot__form" method="post" action="/cart/add"><input type="hidden" name="id" value="' + a(d.vid) + '"><button class="lot__add" type="submit">Add to basket</button></form>' : '<span class="lot__soldtag">Sold</span>')
        + '</div></div></div></article>';
    }

    /* ---------- Main render ---------- */
    function render() {
      if (!ready) return;
      var f = gather();
      var list = sortList(dataset.filter(function (d) { return matches(d, f); }));
      var totalPages = Math.max(1, Math.ceil(list.length / PER_PAGE));
      if (curPage > totalPages) curPage = totalPages; if (curPage < 1) curPage = 1;
      var start = (curPage - 1) * PER_PAGE, pageItems = list.slice(start, start + PER_PAGE);

      byItem = {}; pageItems.forEach(function (d) { byItem[d.sku] = d; });
      if (grid) grid.innerHTML = pageItems.map(catCard).join('');
      if (view === 'table') { buildThead(); tbody.innerHTML = pageItems.map(compactRow).join(''); }
      if (view === 'feature') feature.innerHTML = pageItems.map(lotMarkup).join('');

      if (emptyEl) emptyEl.hidden = list.length !== 0;
      if (grid) grid.style.display = (view === 'grid' && list.length) ? '' : 'none';
      if (tableWrap) tableWrap.hidden = !(view === 'table' && list.length);
      if (feature) feature.hidden = !(view === 'feature' && list.length);

      if (countEl) countEl.textContent = list.length + (list.length === 1 ? ' item' : ' items') + (list.length ? ' · showing ' + (start + 1) + '–' + Math.min(start + PER_PAGE, list.length) : '') + (capped ? ' · filtering the first ' + dataset.length.toLocaleString() + ' of ' + grandTotal.toLocaleString() + '. Narrow by country for the full set' : '');
      buildPager(totalPages);
      renderChips(f);
      writeURL(f);
    }
    function buildPager(totalPages) {
      if (!clientPager) return;
      if (totalPages <= 1) { clientPager.innerHTML = ''; return; }
      var html = pbtn('‹ Prev', curPage - 1, curPage <= 1);
      pageNums(totalPages).forEach(function (p) { html += p === '…' ? '<span class="bhs-pagerx__gap">…</span>' : '<button type="button" class="bhs-pagerx__num' + (p === curPage ? ' is-current' : '') + '" data-page="' + p + '">' + p + '</button>'; });
      html += pbtn('Next ›', curPage + 1, curPage >= totalPages);
      clientPager.innerHTML = html;
      clientPager.querySelectorAll('[data-page]').forEach(function (b) { b.addEventListener('click', function () { curPage = parseInt(b.getAttribute('data-page'), 10); render(); section.scrollIntoView({ block: 'start', behavior: 'smooth' }); }); });
    }
    function pbtn(label, page, disabled) { return disabled ? '<span class="bhs-pagerx__edge is-disabled">' + label + '</span>' : '<button type="button" class="bhs-pagerx__edge" data-page="' + page + '">' + label + '</button>'; }
    function pageNums(total) { var out = [], i; if (total <= 7) { for (i = 1; i <= total; i++) out.push(i); return out; } out.push(1); var lo = Math.max(2, curPage - 1), hi = Math.min(total - 1, curPage + 1); if (lo > 2) out.push('…'); for (i = lo; i <= hi; i++) out.push(i); if (hi < total - 1) out.push('…'); out.push(total); return out; }

    /* ---------- Active chips ---------- */
    function renderChips(f) {
      var html = '', any = false;
      if (f.keyword) { html += chip('Search', '"' + f.keyword + '"', 'kw', ''); any = true; }
      Object.keys(f.cats).forEach(function (k) { f.cats[k].forEach(function (v) { html += chip(FACET_LABEL[k] || k, v, 'cat', k + '|' + v); any = true; }); });
      Object.keys(f.ranges).forEach(function (k) { var lbl = k === 'year' ? 'Year' : (k === 'price' ? 'Price' : 'Cat. value'); html += chip(lbl, (k === 'year' ? f.ranges[k][0] + '–' + f.ranges[k][1] : '£' + f.ranges[k][0] + '–£' + f.ranges[k][1]), 'range', k); any = true; });
      if (any) html += '<button type="button" class="bhs-chip-clear" data-clearall>Clear all</button>';
      chipsEl.innerHTML = html;
      chipsEl.querySelectorAll('[data-rm]').forEach(function (b) {
        b.addEventListener('click', function () {
          var t = b.getAttribute('data-rm');
          if (t === 'kw') { keywordEl.value = ''; }
          else if (t.indexOf('cat|') === 0) { var parts = t.split('|'); var k = parts[1], val = parts.slice(2).join('|'); var cb = filterUiEl.querySelector('input[data-fkey="' + k + '"][value="' + cssEsc(val) + '"]'); if (cb) cb.checked = false; }
          else if (t.indexOf('range|') === 0) { var rk = t.split('|')[1], st = rangeState[rk]; if (st) { st.lo = st.min; st.hi = st.max; if (st.els) { st.els.lo.value = st.min; st.els.hi.value = st.max; st.els.nlo.value = st.min; st.els.nhi.value = st.max; } } }
          curPage = 1; render();
        });
      });
      var ca = chipsEl.querySelector('[data-clearall]'); if (ca) ca.addEventListener('click', clearAll);
    }
    function chip(label, val, type, ref) {
      var rm = type === 'kw' ? 'kw' : (type === 'range' ? 'range|' + ref : 'cat|' + ref);
      return '<span class="bhs-chip"><span class="k">' + e(label) + ':</span> ' + e(val) + '<button type="button" data-rm="' + a(rm) + '" aria-label="Remove ' + a(label) + ' filter">×</button></span>';
    }
    function cssEsc(s) { return String(s).replace(/(["\\\]\[])/g, '\\$1'); }

    /* ---------- URL state ---------- */
    function writeURL(f) {
      var p = new URLSearchParams();
      if (view !== 'grid') p.set('view', view);
      if (sortSel && sortSel.value) p.set('sort', sortSel.value);
      else if (sortState) p.set('sort', sortState.key + '-' + (sortState.asc ? 'asc' : 'desc'));
      if (f.keyword) p.set('q', f.keyword);
      Object.keys(f.cats).forEach(function (k) { p.set(k, f.cats[k].join(',')); });
      Object.keys(f.ranges).forEach(function (k) { p.set(k + '_min', f.ranges[k][0]); p.set(k + '_max', f.ranges[k][1]); });
      if (curPage > 1) p.set('page', curPage);
      var qs = p.toString();
      try { history.replaceState(null, '', qs ? '?' + qs : location.pathname); } catch (ex) {}
    }
    function applyURL() {
      var p = new URLSearchParams(location.search);
      var v = p.get('view'); if (v === 'table' || v === 'feature') view = v;
      if (p.get('q') && keywordEl) keywordEl.value = p.get('q');
      var s = p.get('sort');
      if (s) { if (sortSel) { sortSel.value = s; } applySortValue(s); }
      CATS.forEach(function (c) {
        var raw = p.get(c[0]); if (!raw) return;
        raw.split(',').forEach(function (val) {
          var cb = filterUiEl.querySelector('input[data-fkey="' + c[0] + '"][value="' + cssEsc(val) + '"]');
          if (cb) cb.checked = true;
        });
      });
      Object.keys(rangeState).forEach(function (k) {
        var st = rangeState[k], lo = parseFloat(p.get(k + '_min')), hi = parseFloat(p.get(k + '_max'));
        if (!isNaN(lo)) { st.lo = Math.max(st.min, Math.min(lo, st.max)); }
        if (!isNaN(hi)) { st.hi = Math.max(st.min, Math.min(hi, st.max)); }
        if (st.els) { st.els.lo.value = st.lo; st.els.hi.value = st.hi; st.els.nlo.value = st.lo; st.els.nhi.value = st.hi; }
      });
      var pg = parseInt(p.get('page'), 10); if (pg > 1) curPage = pg;
    }
    var SORTMAP = {
      'price-asc': ['price', 1, 1], 'price-desc': ['price', 1, 0],
      'sg-asc': ['sgnum', 1, 1], 'sg-desc': ['sgnum', 1, 0],
      'sku-asc': ['skunum', 1, 1], 'sku-desc': ['skunum', 1, 0],
      'catval-asc': ['catval', 1, 1], 'catval-desc': ['catval', 1, 0],
      'year-asc': ['year', 1, 1], 'year-desc': ['year', 1, 0],
      'country-asc': ['country', 0, 1], 'title-asc': ['title', 0, 1]
    };
    function applySortValue(v) { if (SORTMAP[v]) sortState = { key: SORTMAP[v][0], numeric: !!SORTMAP[v][1], asc: !!SORTMAP[v][2] }; else { var m = /^(\w+)-(asc|desc)$/.exec(v || ''); if (m) sortState = { key: m[1], numeric: ['price', 'catval', 'year', 'sku', 'sgnum', 'skunum'].indexOf(m[1]) !== -1, asc: m[2] === 'asc' }; } }

    /* ---------- Browse-by chips ---------- */
    function buildBrowse() {
      if (!browseEl || !browseChips) return;
      var counts = {}; dataset.forEach(function (d) { if (d.country) counts[d.country] = (counts[d.country] || 0) + 1; });
      var top = Object.keys(counts).sort(function (x, y) { return counts[y] - counts[x] || x.localeCompare(y); }).slice(0, 12);
      if (top.length < 2) return;
      browseChips.innerHTML = top.map(function (c) { return '<a href="' + a(collUrl + '?country=' + encodeURIComponent(c)) + '">' + e(c) + '</a>'; }).join('');
      browseEl.hidden = false;
    }

    /* ---------- View / per-row / columns ---------- */
    function setView(v) {
      view = v;
      section.classList.toggle('is-tableview', v === 'table');
      section.querySelectorAll('.bhs-collx__viewbtn').forEach(function (b) { b.classList.toggle('is-active', b.getAttribute('data-view') === v); });
      if (gridCtrls) gridCtrls.style.display = v === 'grid' ? '' : 'none';
      if (colsMenuWrap) colsMenuWrap.hidden = v !== 'table';
      try { localStorage.setItem('bhsCollxView', v); } catch (ex) {}
      if (ready) render();
    }

    /* Click a row to transform it in-place into full details (no duplicate row) */
    function toggleRow(tr, force) {
      var d = byItem[tr.getAttribute('data-item')]; if (!d) return;
      var open = typeof force === 'boolean' ? force : !tr.classList.contains('is-expanded');
      tr.classList.toggle('is-expanded', open);
      tr.setAttribute('aria-expanded', open ? 'true' : 'false');
      tr.innerHTML = open ? detailCell(d) : compactCells(d);
    }
    if (tbody) {
      tbody.addEventListener('click', function (ev) {
        var closeB = ev.target.closest('[data-ec-close]');
        if (closeB) { var trc = closeB.closest('tr.ec-row'); if (trc) toggleRow(trc, false); return; }
        if (ev.target.closest('a, button, input, select, label, form')) return; /* let interactive controls work */
        var tr = ev.target.closest('tr.ec-row'); if (tr) toggleRow(tr);
      });
      tbody.addEventListener('keydown', function (ev) {
        if ((ev.key === 'Enter' || ev.key === ' ') && ev.target.classList && ev.target.classList.contains('ec-row')) { ev.preventDefault(); toggleRow(ev.target); }
      });
    }
    section.querySelectorAll('.bhs-collx__viewbtn').forEach(function (b) { b.addEventListener('click', function () { setView(b.getAttribute('data-view')); }); });
    function setCols(n) { if (grid) grid.style.setProperty('--cc-cols', n); section.querySelectorAll('.bhs-collx__colbtn').forEach(function (b) { b.classList.toggle('is-active', b.getAttribute('data-cols') === String(n)); }); try { localStorage.setItem('bhsCollxCols', n); } catch (ex) {} }
    section.querySelectorAll('.bhs-collx__colbtn').forEach(function (b) { b.addEventListener('click', function () { setCols(b.getAttribute('data-cols')); }); });

    function buildColMenu() {
      if (!colMenu) return;
      colMenu.innerHTML = COLUMNS.map(function (c) { return '<label><input type="checkbox" data-col="' + c.k + '"' + (colState[c.k] ? ' checked' : '') + '> ' + e(c.label) + '</label>'; }).join('');
      colMenu.querySelectorAll('input[data-col]').forEach(function (cb) { cb.addEventListener('change', function () { colState[cb.getAttribute('data-col')] = cb.checked; if (view === 'table') render(); }); });
    }

    /* ---------- Sort / keyword / clear ---------- */
    if (sortSel) sortSel.addEventListener('change', function () { var v = sortSel.value; if (!v) { sortState = null; } else applySortValue(v); curPage = 1; render(); });
    if (keywordEl) keywordEl.addEventListener('input', function () { curPage = 1; render(); });
    function clearAll() {
      if (keywordEl) keywordEl.value = ''; if (sortSel) sortSel.value = ''; sortState = null;
      filterUiEl.querySelectorAll('input[data-fkey]:checked').forEach(function (cb) { cb.checked = false; });
      Object.keys(rangeState).forEach(function (k) { var st = rangeState[k]; st.lo = st.min; st.hi = st.max; if (st.els) { st.els.lo.value = st.min; st.els.hi.value = st.max; st.els.nlo.value = st.min; st.els.nhi.value = st.max; } });
      curPage = 1; render();
    }
    section.querySelectorAll('[data-bhs-clear],[data-bhs-clear2]').forEach(function (b) { b.addEventListener('click', clearAll); });
    function closeDrawer() { if (sidebar) sidebar.classList.remove('is-open'); if (filterToggle) filterToggle.setAttribute('aria-expanded', 'false'); }
    if (filterToggle && sidebar) filterToggle.addEventListener('click', function () { var open = sidebar.classList.toggle('is-open'); filterToggle.setAttribute('aria-expanded', open ? 'true' : 'false'); });
    section.querySelectorAll('[data-bhs-closefilters]').forEach(function (b) { b.addEventListener('click', closeDrawer); });
    document.addEventListener('click', function (ev) {
      if (!sidebar || !sidebar.classList.contains('is-open')) return;
      if (sidebar.contains(ev.target) || (filterToggle && filterToggle.contains(ev.target))) return;
      closeDrawer();
    });
    document.addEventListener('keydown', function (ev) { if (ev.key === 'Escape') closeDrawer(); });

    /* ---------- Background full-collection load ---------- */
    function loadAll() {
      var total = parseInt(section.getAttribute('data-total-pages') || '1', 10);
      var loadPages = total;
      if (total > MAX_PAGES) { loadPages = MAX_PAGES; capped = true; }
      if (!dataBody || !collUrl) { finish(); return; }
      if (loadingEl) loadingEl.hidden = false;
      var page = 1;
      (function next() {
        if (page > loadPages) { finish(); return; }
        if (page === 1) { page++; next(); return; } /* page 1 already server-rendered */
        fetch(collUrl + (collUrl.indexOf('?') > -1 ? '&' : '?') + 'view=rows&page=' + page, { headers: { 'X-Requested-With': 'fetch' } })
          .then(function (r) { return r.text(); })
          .then(function (html) {
            var tpl = document.createElement('template'); tpl.innerHTML = '<table><tbody>' + html + '</tbody></table>';
            tpl.content.querySelectorAll('tr').forEach(function (tr) { dataBody.appendChild(tr); });
            page++; next();
          })
          .catch(finish);
      })();
      function finish() {
        if (loadingEl) loadingEl.hidden = true;
        buildDataset(); buildFilterUI(); buildColMenu(); buildBrowse();
        ready = true;
        applyURL();
        if (gridPager) gridPager.hidden = true;
        if (clientPager) clientPager.hidden = false;
        setView(view);
        render();
      }
    }

    /* ---------- Init ---------- */
    var savedCols, savedView;
    try { savedCols = localStorage.getItem('bhsCollxCols'); savedView = localStorage.getItem('bhsCollxView'); } catch (ex) {}
    setCols(savedCols || 4);
    view = (savedView === 'table' || savedView === 'feature') ? savedView : 'grid';
    loadAll();
  }

  if (document.readyState !== 'loading') boot();
  else document.addEventListener('DOMContentLoaded', boot);
})();
